import React from 'react';
import { parseInlineMarkdown } from '../utils/inline-markdown';

type InlineMarkdownTextProps = {
  text: string;
};

export const InlineMarkdownText: React.FC<InlineMarkdownTextProps> = ({ text }) => {
  const segments = parseInlineMarkdown(text);
  if (segments.length === 0) {
    return null;
  }

  return (
    <>
      {segments.map((segment, index) => {
        let node: React.ReactNode = segment.text;
        if (segment.marks.strike) {
          node = <s>{node}</s>;
        }
        if (segment.marks.italic) {
          node = <em>{node}</em>;
        }
        if (segment.marks.bold) {
          node = <strong>{node}</strong>;
        }
        return <React.Fragment key={index}>{node}</React.Fragment>;
      })}
    </>
  );
};
